import { Link } from "react-router-dom";
import { PageHeader, Panel } from "../../components/ui";
import { partnerQueryKeys } from "../../api/queryKeys";
import { fetchPartnerFaqs } from "../../api/endpoints/program";
import usePartnerQuery from "../../hooks/usePartnerQuery";
import FaqPanel from "./FaqPanel";
import SupportTicketsPanel from "./SupportTicketsPanel";

/**
 * Two ways to reach a person. A specific issue gets a support ticket with its own thread and
 * status; a general question goes to the Messages inbox. The FAQ is the office's own, and
 * an organization that has written none simply does not show one.
 */
const HelpPage = () => {
  const { data: faqs } = usePartnerQuery(partnerQueryKeys.faqs(), fetchPartnerFaqs);

  return (
    <div>
      <PageHeader title="Help & Support" />
      <div className="mb-4">
        <SupportTicketsPanel />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <FaqPanel faqs={faqs} />
        <Panel title="General questions">
          <p className="text-sm text-slate-600 m-0">
            For anything general, message the partner team from Messages. Questions about one client
            belong on that client&apos;s page, and a specific issue you need resolved is best raised
            as a support ticket above.
          </p>
          <Link
            to="/partner/alerts"
            className="inline-block mt-4 rounded-lg bg-teal-600 px-4 py-2 text-xs font-semibold text-white no-underline"
          >
            Open messages
          </Link>
        </Panel>

        <Panel title="Where things live">
          <ul className="list-none p-0 m-0 space-y-2 text-sm text-slate-600">
            <li>
              <Link
                to="/partner/clients?tab=leads"
                className="text-teal-700 no-underline font-medium"
              >
                Leads
              </Link>{" "}
              to start a referral and send the client a form link.
            </li>
            <li>
              <Link to="/partner/documents" className="text-teal-700 no-underline font-medium">
                Documents
              </Link>{" "}
              for anything the office has asked you to collect.
            </li>
            <li>
              <Link to="/partner/payments" className="text-teal-700 no-underline font-medium">
                Referral payments
              </Link>{" "}
              for what you have earned, approved and been paid.
            </li>
            <li>
              <Link to="/partner/settings" className="text-teal-700 no-underline font-medium">
                Settings
              </Link>{" "}
              for your profile, business and payout details.
            </li>
          </ul>
        </Panel>
      </div>
    </div>
  );
};

export default HelpPage;
